import React from 'react'
import Header from '../components/Header'
import "./Styles.css"
import Footer from '../Sections/Footer'


const Terms = () => {
    return (
        <div className='pages-wrapper-main'>
            <Header />
            <div className='heading2'>Terms & Conditions</div>
            <div className='pages'>
                <h5>1. Acceptance of Terms:</h5>

                Clarification:

                By accessing or using our website or services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you may not access the website or use our services.
                <br></br>
                <br></br>

                <h5>2. User Rights and Responsibilities:</h5>

                User Rights:

                Users have the right to access and use our services in accordance with these Terms and Conditions.

                Users may also have additional rights as outlined in our Privacy Policy and other applicable policies.


                User Responsibilities:

                Users are responsible for providing accurate and up-to-date information when using our services.

                Users must comply with all applicable laws and regulations when accessing or using our website or services.

                Users are expected to conduct themselves in a manner that respects the rights and interests of others in the community.
                <br></br>
                <br></br>

                <h5>3. Intellectual Property:</h5>

                Ownership:

                All content, including text, graphics, logos, and images, on our website is the property of Intern Crafters or its licensors and is protected by copyright laws.

                Permitted Uses:

                Users may access and view the content on our website for personal and non-commercial use only.

                Users may not modify, reproduce, distribute, or create derivative works based on our content without prior written consent.
                <br></br>
                <br></br>

                <h5>4. Limitation of Liability:</h5>

                Company Liability:

                Intern Crafters shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from the use of our website or services.

                Third-Party Content and Services:

                We disclaim any responsibility for the accuracy or reliability of third-party content or services linked to or from our website.

                <br></br>
                <br></br>
                <h5>5. Termination:</h5>

                Conditions for Termination:

                Intern Crafters reserves the right to terminate or suspend user accounts at any time for violation of these Terms and Conditions or for any other reason deemed appropriate by Intern Crafters.

                Notice and Appeal Procedures:

                In the event of account termination, Intern Crafters will provide notice to the affected user and may offer an opportunity to appeal the decision.
                <br></br>
                <br></br>

                <h5>6. Changes to Terms:</h5>

                Updates to Terms:

                Intern Crafters reserves the right to update or modify these Terms and Conditions at any time without prior notice.

                Users will be notified of any changes to these terms through a prominent notice on our website or via email.
            </div>
            <Footer />
        </div>
    )
}

export default Terms
